export interface IntegrationConnectionStatusError {
    type: 'CONFIGURATION_ERROR';

    message?: string;
}

export function createIntegrationConnectionStatusError(
    message?: string,
): IntegrationConnectionStatusError {
    return {
        message,
        type: 'CONFIGURATION_ERROR',
    };
}
